import { render, staticRenderFns } from "./videoloader.vue?vue&type=template&id=067fe7ff&"
import script from "./videoloader.vue?vue&type=script&lang=js&"
export * from "./videoloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports